import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = ({ currentPage }) => {
  const menuItems = [
    { name: 'Assets', icon: '📊', path: '/assets' },
    { name: 'Activity', icon: '🕒', path: '/activity' },
    { name: 'Earn & Rewards', icon: '⭐', badge: 'New', path: '/earn' },
    { name: 'Explore', icon: '🧭', path: '/explore' },
    { name: 'Settings', icon: '⚙️', path: '/settings' }
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h1 className="sidebar-title">OISY Prototype</h1>
      </div>
      <nav>
        <ul className="nav-menu">
          {menuItems.map((item) => (
            <li key={item.name} className="nav-item">
              <Link
                to={item.path}
                className={`nav-link ${currentPage === item.name ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {item.name}
                {item.badge && <span className="badge">{item.badge}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
